<template>
  <button-el
    class="square-btn disable-btns-rules"
    :disabled="disabled"
    v-on="$listeners"
  >
    <slot></slot>
  </button-el>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
  },
};
</script>


<style lang="scss" scoped>
  .square-btn {
    cursor: pointer;
    background: $white-color2 !important;
    width: 70px !important;
    height: 70px !important;
    border-radius: 4px !important;
    box-shadow: 3px 3px 8px $black-color8 !important;
    outline: none !important;
    border: none !important;
    &[disabled] {
      cursor: not-allowed;
      box-shadow: 3px 3px 8px $black-color8;
      opacity: 0.85;
    }
    &:hover {
      background: $white-color2;
    }
    &:active {
      box-shadow: 0px 0px 5px $black-color8;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/uikit/SquareBtn.vue